// extracted by mini-css-extract-plugin
export default {"contactItems":"InfoItem_contactItems__XG0nG","socialIcons":"InfoItem_socialIcons__+EzPA"};